import React, { useState } from "react";
// Formik Validation
import "assets/scss/custom/pages/_signup.scss";
import ToastDialog from "components/Common/ToastDialog";
import API_SERVICES from "constants/app.constants";
import CryptoJS from "crypto-js";
import { useFormik } from "formik";
import { resetPassword } from "http/auth/reset";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Popover,
  PopoverBody,
  Row,
} from "reactstrap";
import * as Yup from "yup";
import lightlogo from "../../assets/images/cashinvoice-white-logo.svg";
import verificationImg from "../../assets/images/5024147-Photoroom.png";
import colorlogo from "../../assets/images/ci_logo.png";


const ResetPassword = () => {
  const navigate = useNavigate();
  const [popovertop, setpopovertop] = useState(false);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isInvalid, setIsInvalid] = useState(false);
  const [visible, setVisible] = useState(false);
  document.title = "Reset Password | FundLync";

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tk = queryParams.get("tk");

  //form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .matches(API_SERVICES.PASSWORD_PATTERN, "Enter valid password pattern")
        .required("Password is required"),
      confirm_password: Yup.string().when("password", {
        is: (val) => (!!(val && val.length > 0)),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Both password need to be the same"
        ),
      }),
    }),
    onSubmit: (values) => {
      submitUserLogin(values);
    },
  });

  const submitUserLogin = (values) => {
    const passphrase = process.env.REACT_APP_KEY;
    const encrypted = CryptoJS.AES.encrypt(
      values.password,
      passphrase
    ).toString();
    const encryptedRe = CryptoJS.AES.encrypt(
      values.confirm_password,
      passphrase
    ).toString();
    const postParams = {
      password: encrypted,
      confirm_password: encryptedRe,
      token: tk,
    };
    resetPassword(postParams)
      .then((response) => {
        if (response.status) {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "success" });
          setTimeout(() => {
            navigate("/login");
          }, 1000);
        } else {
          const { message } = response;
          setToastInfo({ message: message, showToast: true, role: "error" });
          setIsInvalid(true);
        }
      })
      .catch((e) => {
        validation.setSubmitting(false);
      })
      .finally((f) => {
        validation.setSubmitting(false);
      });
  };

  return (
    <React.Fragment>
      <div className="account-pages account-pages-bg bg-color login-page">
        <Row className="justify-content-center m-auto h-100vh scrollable-height" style={{width:'90%'}}>
          <Col xl={8} className="d-none d-lg-block">
            <div className="left-section h-100">
              <img src={lightlogo} alt="" className="img-fluid ci-logo" style={{width:'200px'}}/>
              <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                <img
                  src={verificationImg}
                  alt=""
                  className="img-fluid verification-img"
                />
              </div>
            </div>
          </Col>
          <Col
             md={6}
             lg={5}
             xl={4}
             className="form-layout-section m-auto d-flex justify-content-center"
          >
             <div className="d-flex w-100 justify-content-center d-block d-md-none">
              <img src={colorlogo} alt="" className="img-fluid ci-logo" />
            </div>
            <div className="p-2">
              <div className="d-flex flex-column align-items-left">
                <h3 className="mt-3 mb-3 header-reg">Reset Password</h3>
              </div>

              <Form
                className="needs-validation"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-floating mb-3">
                  <div className="password-info">
                    <div className="form-floating">
                      <Input
                        name="password"
                        placeholder="Enter Valid Password"
                        type={visible ? "text" : "password"}
                        className="form-control"
                        id="validationCustom04"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        style={{
                          backgroundImage: "none",
                        }}
                        invalid={
                          !!(
                            validation.touched.password &&
                            validation.errors.password
                          )
                        }
                        disabled={validation.isSubmitting}
                      />

                      <Label htmlFor="validationCustom04">Password</Label>
                      {validation.touched.password &&
                      validation.errors.password ? (
                        <FormFeedback type="invalid">
                         {validation.errors.password ===
                            "Enter valid password pattern" ? (
                              <div style={{ marginLeft: "1rem" }}>
                                {validation.errors.password}
                              </div>
                            ) : (
                              validation.errors.password
                            )}
                        </FormFeedback>
                      ) : null}
                    </div>
                    {validation.touched.password &&
                    validation.errors.password ===
                      "Enter valid password pattern" ? (
                      <div
                        className="password-j"
                        id="passwordInfo"
                        onMouseOver={() => {
                          setpopovertop(!popovertop);
                        }}
                        onMouseOut={() => {
                          setpopovertop(!popovertop);
                        }}
                      >
                        <i
                          style={{ color: "#f46a6a" }}
                          className="mdi mdi-information-outline"
                        ></i>
                      </div>
                    ) : (
                      <div id="passwordInfo" />
                    )}

                    <div
                      onClick={() => setVisible(!visible)}
                      className="password-i"
                      id="passwordInfo"
                    >
                      {visible ? (
                        <i className="mdi mdi-eye"></i>
                      ) : (
                        <i className="mdi mdi-eye-off"></i>
                      )}
                    </div>
                  </div>

                  <Popover
                    className="password-dialog"
                    placement="left"
                    trigger="focus"
                    isOpen={popovertop}
                    target="passwordInfo"
                    toggle={() => {
                      setpopovertop(!popovertop);
                    }}
                  >
                    <PopoverBody>
                      <div className="d-flex flex-column">
                        <span className="title">Requirements</span>
                        <ul className="mt-2">
                          <li>Min. 8 Char. length</li>
                          <li>Min 1 lower-case</li>
                          <li>Min 1 upper-case</li>
                          <li>Min 1 special char(!,@,#,etc.)</li>
                          <li>Letter and numbers</li>
                        </ul>
                      </div>
                    </PopoverBody>
                  </Popover>
                </div>

                <div className="form-floating mb-3">
                  <Input
                    name="confirm_password"
                    type="password"
                    placeholder="Password"
                    id="validationPassword"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.confirm_password || ""}
                    invalid={
                      !!(validation.touched.confirm_password &&
                      validation.errors.confirm_password)
                    }
                    disabled={validation.isSubmitting}
                  />
                  <Label htmlFor="validationPassword">Confirm Password</Label>
                  {validation.touched.confirm_password &&
                  validation.errors.confirm_password ? (
                    <FormFeedback type="invalid">
                      {validation.errors.confirm_password}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="w-100 mt-3 d-flex justify-content-center">
                  <Button color="primary" type="submit">
                    {validation.isSubmitting && (
                      <span
                        className="spinner-border spinner-border-sm ms-2 me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}
                    {!validation.isSubmitting && <span>Reset Password</span>}
                    {validation.isSubmitting && <span>Authenticating</span>}
                  </Button>
                </div>
              </Form>
              {isInvalid && (
                <div className="mt-2 text-center">
                  <p>
                    You already reset password ?{" "}
                    <Link
                      to="/login"
                      className="fw-medium text-primary"
                    >
                      {" "}
                      Login
                    </Link>{" "}
                  </p>
                </div>
              )}
            </div>
            <div className="mt-2 text-center">
              <p>
                Remembered?{" "}
                <Link to="/login" className="fw-medium text-primary">
                  Log In
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default ResetPassword;
